import type { ZoneDTO } from "../api/client";
import { RowActions } from "@/shared/ui/RowActions";
import { DataTable, type TanstackReactTable } from "@devhop/ui";
import { EditIcon } from "lucide-react";

function nameLo(row: ZoneDTO): string {
  return (row.name as { lo?: string })?.lo ?? "—";
}

type ZonesTableProps = {
  canManage: boolean;
  isLoading: boolean;
  data: ZoneDTO[];
  onEdit: (row: ZoneDTO) => void;
};

export function ZonesTable({
  canManage,
  isLoading,
  data,
  onEdit,
}: ZonesTableProps) {
  const columns: TanstackReactTable.ColumnDef<ZoneDTO>[] = [
    {
      id: "code",
      header: "ລະຫັດ",
      cell: ({ row }) => row.original.code,
      size: 100,
    },
    {
      id: "nameLo",
      header: "ຊື່ (ລາວ)",
      cell: ({ row }) => nameLo(row.original),
      size: 120,
    },
    {
      id: "nameTh",
      header: "ຊື່ (ไทย)",
      cell: ({ row }) => (
        <span className="text-muted-foreground text-sm">
          {(row.original.name as { th?: string })?.th ?? "—"}
        </span>
      ),
      size: 100,
    },
    {
      id: "nameEn",
      header: "ຊື່ (EN)",
      cell: ({ row }) => (
        <span className="text-muted-foreground text-sm">
          {(row.original.name as { en?: string })?.en ?? "—"}
        </span>
      ),
      size: 100,
    },
    {
      id: "sortOrder",
      header: "ລຳດັບ",
      cell: ({ row }) => row.original.sortOrder,
      size: 80,
    },
    {
      id: "actions",
      cell: ({ row }) => {
        if (!canManage) return null;
        const actions = [
          {
            label: "ແກ້ໄຂ",
            icon: <EditIcon className="h-4 w-4" />,
            onClick: () => onEdit(row.original),
          },
        ];
        return <RowActions actions={actions} maxInline={2} />;
      },
      size: 100,
    },
  ];

  const totalCount = data.length;
  const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
  const limit =
    totalCount === 0
      ? 20
      : PAGE_SIZE_OPTIONS.find((n) => n >= totalCount) ?? 100;

  return (
    <div data-tourid="shipping-zones-table">
      <DataTable<ZoneDTO, unknown>
        noDataMessage="ບໍ່ພົບໂຊນ"
        isLoading={isLoading}
        columns={columns}
        data={data}
        offset={0}
        limit={limit}
        totalCount={totalCount}
        onPaginationChange={() => {}}
      />
    </div>
  );
}
